module.exports = __webpack_public_path__ + "img/DW365-233.e08d77c9.jpg";